type callFunc = (...args: any[]) => any;
type conditionedFunc = any;
type callFuncArg = callFunc | null | conditionedFunc[];
/**
 * Call function
 * @param func
 * @param args
 */
export const call = <T = any>(func?: callFuncArg, ...args: any[]): T | undefined | void => {
    if (func && Array.isArray(func)) {
        // @ts-ignore
        return func.map((fn) => {
            if (typeof fn === 'object' && Array.isArray(fn)) {
                if (!fn[0]) {
                    return null;
                }
            }

            return call<T>(fn, ...args);
        });
    }

    if (func && typeof func === 'function') {
        return func(...args);
    }
};

export const callFn = call;
